/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const EMAIL_SEND = 'EMAIL_SEND';
export const CONTACTFORM_SUBMIT = 'CONTACTFORM_SUBMIT';
export const TOGGLE_LIKE = 'TOGGLE_LIKE';
export const POSTPONE_REVIEW = 'POSTPONE_REVIEW';
export const DELEGATE_REVIEW = 'DELEGATE_REVIEW';
export const APPROVE_REVIEW = 'APPROVE_REVIEW';
